export const environment = {
    appVersion: require('../../package.json').version,
    production: false,
    apiUrl: 'https://app-api-aglet-uat4-eastus2.azurewebsites.net',
    environment: 'UAT4'
};
